// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/dark-gradient-left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/dark-gradient-right.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-box1 {
  position: absolute;
  left: 5px;
  right: 5px;
  top: 5px;
  bottom: 5px;
  z-index: 0;
}
.background-box2 {
  position: absolute;
  left: 7px;
  right: 7px;
  top: 5px;
  bottom: 5px;
  z-index: 1;
}
.background-box3 {
  position: absolute;
  left: 9px;
  right: 9px;
  top: 5px;
  bottom: 5px;
  z-index: 2;
  /* display: flex;
  justify-content: space-between;
  place-content: center; */
  overflow: hidden;
}

.book-spine {
  position: absolute;
  width: 1px;
  height: 100%;
  position: absolute;
  left: 50%;
  /* bottom: 100%; */
  bottom: 0;
  /* border: 2px solid rgba(191, 191, 191, 1); */
  border-left: none;
  box-sizing: border-box;
  z-index: 10;
}

.spine-shadow-left {
  width: 68px;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-y;
  z-index: 10;
  margin: 0;
  z-index: 10;
  position: absolute;
  left: calc(50% - 68px);
  opacity: 0.125;
}

.spine-shadow-right {
  width: 68px;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) repeat-y;
  z-index: 10;
  margin: 0;
  box-sizing: border-box;
  position: absolute;
  right: calc(50% - 68px);
  opacity: 0.125;
}
.single-background {
  width: 60vw;
  left: 20vw;
}
`, "",{"version":3,"sources":["webpack://./src/components/background/background.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV;;0BAEwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,8CAA8C;EAC9C,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4DAAsE;EACtE,WAAW;EACX,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4DAAuE;EACvE,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;AACZ","sourcesContent":[".background-box1 {\n  position: absolute;\n  left: 5px;\n  right: 5px;\n  top: 5px;\n  bottom: 5px;\n  z-index: 0;\n}\n.background-box2 {\n  position: absolute;\n  left: 7px;\n  right: 7px;\n  top: 5px;\n  bottom: 5px;\n  z-index: 1;\n}\n.background-box3 {\n  position: absolute;\n  left: 9px;\n  right: 9px;\n  top: 5px;\n  bottom: 5px;\n  z-index: 2;\n  /* display: flex;\n  justify-content: space-between;\n  place-content: center; */\n  overflow: hidden;\n}\n\n.book-spine {\n  position: absolute;\n  width: 1px;\n  height: 100%;\n  position: absolute;\n  left: 50%;\n  /* bottom: 100%; */\n  bottom: 0;\n  /* border: 2px solid rgba(191, 191, 191, 1); */\n  border-left: none;\n  box-sizing: border-box;\n  z-index: 10;\n}\n\n.spine-shadow-left {\n  width: 68px;\n  height: 100%;\n  background: url(\"../../assets/images/dark-gradient-left.png\") repeat-y;\n  z-index: 10;\n  margin: 0;\n  z-index: 10;\n  position: absolute;\n  left: calc(50% - 68px);\n  opacity: 0.125;\n}\n\n.spine-shadow-right {\n  width: 68px;\n  height: 100%;\n  background: url(\"../../assets/images/dark-gradient-right.png\") repeat-y;\n  z-index: 10;\n  margin: 0;\n  box-sizing: border-box;\n  position: absolute;\n  right: calc(50% - 68px);\n  opacity: 0.125;\n}\n.single-background {\n  width: 60vw;\n  left: 20vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
